import { Component, Input, OnChanges, OnDestroy } from '@angular/core';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

import { MAIN_DOMAIN } from '@app/app.constants';
import { Lesson, LessonPrivilegeSetting, Pupil, StudentPrivilegeSetting } from '@df/interfaces';
import { PrivilegeService } from '@app/core/services/privilege.service';

@Component({
    selector: 'app-manage-privilege',
    templateUrl: './manage-privilege.component.html',
    styleUrls: ['./manage-privilege.component.scss']
})
export class ManagePrivilegeComponent implements OnChanges, OnDestroy {
    @Input() student: Pupil;
    @Input() privilege: LessonPrivilegeSetting;
    @Input() lesson: Lesson;
    @Input() studentPrivilegeSettings: Array<StudentPrivilegeSetting>;
    main_domain = MAIN_DOMAIN;
    checked: boolean = false;
    studentPrivilege: StudentPrivilegeSetting;
    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(private privSvc: PrivilegeService) {}

    public ngOnChanges(): void {
        if (this.studentPrivilegeSettings.length > 0) {
            for (const studentPriv of this.studentPrivilegeSettings) {
                if (studentPriv.student === this.student.id && studentPriv.settings === this.privilege.id) {
                    this.checked = true;
                    this.studentPrivilege = studentPriv;
                    break;
                }
            }
        }
    }

    public checkBoxClicked(): void {
        if (this.studentPrivilege) {
            this.privSvc
                .deleteStudentPrivilegeSetting(this.studentPrivilege.id)
                .pipe(takeUntil(this.destroy$))
                .subscribe(() => {
                    this.privSvc.privilegeSettingSelected.next(null);
                });
            const index = this.studentPrivilegeSettings.indexOf(this.studentPrivilege);
            this.studentPrivilegeSettings.splice(index, 1);
            this.studentPrivilege = null;
            this.checked = false;
        } else {
            this.checked = true;
            this.privSvc
                .createStudentPrivilegeSetting(this.student.id, this.privilege.id)
                .pipe(takeUntil(this.destroy$))
                .subscribe(response => {
                    this.studentPrivilege = response;
                    this.studentPrivilegeSettings.push(this.studentPrivilege);
                    this.privSvc.privilegeSettingSelected.next(this.studentPrivilege);
                });
        }
    }

    ngOnDestroy() {
        this.destroy$.next(true);
    }
}
